module.exports = __webpack_public_path__ + "static/Android_iOS-24bf8eabad6c4b794467efab286a2d5e.mp4";